import { isAbortError } from '@reatom/framework'
import * as Sentry from '@sentry/react'

import { run } from './app/main'
import { APP_MODE_PRODUCTION, environment, TRADE_API_URL } from './shared'
import { startBrowserTiming } from './shared/lib/browser-timing'

Sentry.init({
  dsn: environment.sentryDsn,
  integrations: [
    Sentry.browserTracingIntegration(),
    // Sentry.replayIntegration({}),
  ],
  tracesSampleRate: 1.0, //  Capture 100% of the transactions
  // tracePropagationTargets: ['localhost'],
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  debug: false,
  enabled: APP_MODE_PRODUCTION,
  beforeSend(event, hint) {
    if (isAbortError(hint.originalException)) {
      // eslint-disable-next-line unicorn/no-null
      return null
    }
    return event
  },
})

window.addEventListener('unhandledrejection', (e) => {
  if (isAbortError(e.reason)) {
    e.preventDefault()
  }
})

// Report what this browser saw — page milestones and how long each API call
// really took, network and queue included. The services can only time
// themselves from inside a handler, and the gap between the two is the whole
// question of whether the terminal is fast.
startBrowserTiming(TRADE_API_URL)

run()
